export interface FontAsset {
	id: number,
	url: string,
	name: string,
	originalName: string
}

// string is the associated_key font-1 font-2
export type KeyedFontAsset = Record<string, FontAsset>;

export interface FontAssetUploadAlert {
	message: string,
	description: string,
	type: string,
	duration: number
}

export enum FontUploadAlert {
	Generic = 'generic',
	DefaultExists = 'defaultExists',
	ExistingOverriden = 'existingOverriden'
}

export const fontAssetUploadAlerts: Record<FontUploadAlert, FontAssetUploadAlert> = {
	[FontUploadAlert.DefaultExists]: {
		message: 'Cannot upload font',
		description: 'This is a default font and cannot be replaced',
		type: 'general-error',
		duration: 5000
	},
	[FontUploadAlert.ExistingOverriden]: {
		message: 'Font replaced',
		description: 'You uploaded a duplicate font, so we replaced it for you',
		type: 'font-alert-replaced',
		duration: 5000
	},
	[FontUploadAlert.Generic]: {
		message: 'Font error',
		description: 'Error uploading font, please try again',
		type: 'general-error',
		duration: 5000
	},
}